import React, { useEffect, useState } from "react";
import "./navegador.css";
import { getStaticUrl } from "../../../../utils/getStaticUrl";
import { useNavigate } from "react-router-dom";

const boxes = [
  { id: 1, title: "Nosotras", icon: "icons/nosotras.png", link: "/nosotras" },
  {
    id: 2,
    title: "Convocatorias",
    icon: "icons/convocatorias.png",
    link: "/convocatorias",
  },
  {
    id: 3,
    title: "Programas",
    icon: "icons/programas.png",
    link: "/programas",
  },
  { id: 4, title: "Noticias", icon: "icons/noticias.png", link: "/noticias" },
  {
    id: 5,
    title: "Testimonios",
    icon: "icons/testimonios.png",
    link: "/testimonios",
  },
  {
    id: 6,
    title: "WCB_Latam",
    icon: "icons/wbc-latam.png",
    link: "/noticias/news143",
  },
];

const Navegador = () => {
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(true), 50); // slight delay
    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="navegador-container">
      {boxes.map((box, index) => (
        <div
          key={box.id}
          className={`nav-box ${animate ? "fade-in" : ""}`}
          style={{ animationDelay: `${index * 100}ms`, cursor: "pointer" }}
          onClick={() => navigate(box.link)}
        >
          <img
            src={getStaticUrl(box.icon)}
            alt={box.title}
            className="nav-icon"
          />
          <span>{box.title}</span>
        </div>
      ))}
    </div>
  );
};

export default Navegador;
